/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Pleaseselectoption6Inputs */

const en_coinvestments_lpdealoverviewcontent_pleaseselectoption6 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Pleaseselectoption6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select an option`)
};

/**
* | output |
* | --- |
* | "Please select an option" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Pleaseselectoption6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_pleaseselectoption6 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Pleaseselectoption6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Pleaseselectoption6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_pleaseselectoption6(inputs)
});
export { coinvestments_lpdealoverviewcontent_pleaseselectoption6 as "coInvestments_lpDealOverviewContent_pleaseSelectOption" }